//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { computed } from '@vue/composition-api'
import { formatCurrency } from '@core/utils'

export default {
  name: 'SelectTeam',
  model: {
    prop: 'selected',
    event: 'update:selected',
  },
  props: {
    selected: {
      type: Number,
      default: 1,
    },
    teams: {
      type: Array,
      default: () => [],
      required: true,
    },
  },
  setup(props, { emit }) {
    const selectedRadio = computed({
      get: () => props.selected,
      set: value => emit('update:selected', value),
    })

    return {
      selectedRadio,

      formatCurrency,

      icons: {
        teamShield: require('@/assets/images/svg/team-shield.svg'),
      },
    }
  },
}
